import './application_header.css';

/*
 * Description: Application Header Web Component
 * Purpose: A reusable application header component specifically designed for the top div of the application
 * Author: Nuvemx
 * Created: 2026
 * 
 * Features:
 * - Displays a logo
 * 
 * Usage:
 * <application-header logo-image="images/profile-image.png"></application-header>
 * 
 * Attributes:
 * - logo-image: String - The filename of the image to display in the header
 * 
  */

class application_header extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const logo_image = this.getAttribute("logo-image");
        this.innerHTML = `
        <header class="header" id="header">
                <div class="header_toggle"><i class='bx bx-menu' id="header-toggle"></i> </div>
                <div class="header_img"><img src="${logo_image}" alt=""> </div>
            </header>`;
        this.dataset.rendered = "true";
    }
}

export { application_header };